import { getRequest } from '../services/requestHandler';
import { Family } from '../models';

//5537, 3 for testing
export const getFamily = async () => {
  const url = `family?activeOnly=true`;
  const response = await getRequest<Family>('Family', url);
  return response;
};
